import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CategoriesState, Image } from '../../types';
import { ImageUsageManager, ImageStatus } from '../../utils/ImageUsageManager';
import { AppThunk } from '../index';

const initialState: CategoriesState = {
  categories: [],
  currentCategory: null,
  currentImage: null,
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    setCategories: (state, action: PayloadAction<Array<{ id: string; name: string; thumbnail: string; images: Image[] }>>) => {
      state.categories = action.payload;
    },
    setCurrentCategory: (state, action: PayloadAction<{ id: string; name: string; thumbnail: string; images: Image[] } | null>) => {
      state.currentCategory = action.payload;
    },
    setCurrentImage: (state, action: PayloadAction<Image | null>) => {
      state.currentImage = action.payload;
    },
    // This action is kept for API compatibility but doesn't modify state anymore
    // Instead, it uses a side effect in the thunk to update the persistent storage
    updateImageUsage: (state, action: PayloadAction<{ imageId: string, categoryId: string }>) => {
      // No longer modifies the Redux state
      // The actual update happens via a middleware or useEffect when this action is dispatched
    },
  },
});

export const { setCategories, setCurrentCategory, setCurrentImage, updateImageUsage } = categoriesSlice.actions;

// Thunk to update image usage in persistent storage
export const updateImageUsageAndPersist = (payload: { 
  imageId: string, 
  categoryId: string, 
  status?: ImageStatus 
}): AppThunk => async (dispatch) => {
  const { imageId, categoryId, status = ImageStatus.IN_PROGRESS } = payload;
  
  // First dispatch the regular action (for compatibility)
  dispatch(updateImageUsage(payload));
  
  // Then update the persistent storage
  try {
    await ImageUsageManager.getInstance().updateImageUsage(categoryId, imageId, Date.now(), status);
  } catch (error) {
    console.error('Failed to persist image usage:', error);
  }
};

export default categoriesSlice.reducer; 